import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=a6800b9c&"
import script from "./custom.vue?vue&type=script&lang=ts&"
export * from "./custom.vue?vue&type=script&lang=ts&"
import style0 from "./custom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports